"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = void 0;
// fetch room
// rights
require("reflect-metadata");
const rightService_1 = require("./services/rightService/rightService");
const tsyringe_1 = require("tsyringe");
const fetchRoomService_1 = require("./services/fetchRoomService/fetchRoomService");
const childContainer = tsyringe_1.container.createChildContainer();
exports.utils = {
    rightService: childContainer.resolve(rightService_1.RightService),
    fetchRoomService: childContainer.resolve(fetchRoomService_1.FetchRoomService)
};
//# sourceMappingURL=index.js.map